import { ReactNode } from 'react';
import { Inline } from '../../../design-system/inline/inline';
import { TabsList, Tabs as TabsRoot, TabsTrigger } from '../../../design-system/tabs/tabs-primitives';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';

type TabValue = 'CASH_FLOW' | 'REPORT';

export type TabTrigger = {
  value: TabValue;
};

type ReportingTabsWrapperProps = {
  triggers: TabTrigger[];
  children: ReactNode;
  defaultValue?: TabValue;
  onValueChange: (value: string) => void;
};

export const ReportingTabsWrapper = ({
  triggers,
  children,
  defaultValue = 'CASH_FLOW',
  onValueChange,
}: ReportingTabsWrapperProps) => {
  return (
    <TabsRoot defaultValue={defaultValue} onValueChange={onValueChange}>
      <TabsList className="mb-5 w-full rounded-none px-32">
        <Inline space={8}>
          {triggers.map((trigger) => {
            const tabTriggerText = getTabTriggerText(trigger.value);

            return (
              <TabsTrigger
                key={trigger.value}
                value={trigger.value}
                className="rounded-none px-0 py-0 text-seapoint-gray outline-offset-8 data-[state=active]:bg-white"
              >
                <Inline space={2}>
                  <p className="border-b-2 border-b-transparent text-base font-medium leading-6 tracking-tight text-seapoint-gray group-data-[state=active]:border-b-seapoint-yellow group-data-[state=active]:text-black">
                    {tabTriggerText}
                  </p>
                </Inline>
              </TabsTrigger>
            );
          })}
        </Inline>
      </TabsList>

      {children}
    </TabsRoot>
  );
};

const getTabTriggerText = (tabValue: TabValue) => {
  switch (tabValue) {
    case 'CASH_FLOW':
      return 'Cash flow';
    case 'REPORT':
      return 'Report';
    default:
      return exhaustiveCheck(tabValue);
  }
};

export default ReportingTabsWrapper;
